module.exports = __webpack_public_path__ + "media/images/undraw_team-03a83bcf117bcfb29414385d7e2a6386.svg";